import type { JSX } from 'react'

export const BundleCover6 = (): JSX.Element => (
  <svg
    width='100%'
    height='100%'
    viewBox='0 0 1920 1080'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    preserveAspectRatio='none'
  >
    <rect width='1920' height='1080' fill='#161616' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1111.11 0C1045.14 117.748 977.162 243.053 911.825 369.42C785.184 614.359 665.865 868.176 591.559 1080H761.708C832.042 892.133 937.576 667.986 1053.95 442.904C1133.11 289.809 1216.27 138.174 1294.84 0H1111.11Z'
      fill='url(#paint0_linear_628_273)'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0 658.42C191.105 468.033 462.274 198.249 626.224 36.1743C557.505 144.806 479.93 268.406 401.253 395.396C256.395 629.205 105.82 877.647 0 1065.74V1080H175.932C275.684 906.317 407.32 689.402 537.265 479.663C647.136 302.324 754.678 131.893 838.7 0H435.341C306.795 127.377 143.023 290.225 0 432.61V658.42ZM1304.3 0C1225.71 69.1244 1138.72 149.222 1043.37 241.582C907.345 373.336 758.186 523.486 614.024 668.719L603.769 679.05L603.754 679.065C462.952 820.918 327.468 957.411 212.911 1068.2C208.802 1072.17 204.728 1076.11 200.687 1080H429.565C519.304 991.266 617.015 892.825 716.611 792.487L727.58 781.436C871.961 635.981 1019.99 486.975 1154.69 356.507C1310.81 205.285 1443.11 88.5098 1551.39 0H1304.3Z'
      fill='url(#paint1_linear_628_273)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_628_273'
        x1='946.867'
        y1='-126.427'
        x2='946.867'
        y2='1183.5'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#212B53' />
        <stop offset='1' stopColor='#171617' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_628_273'
        x1='766.211'
        y1='-74.1718'
        x2='766.211'
        y2='1172.26'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#232C51' />
        <stop offset='1' stopColor='#262526' />
      </linearGradient>
    </defs>
  </svg>
)
